/**
 * CommunityTab — Tab 3 of the patient-edit shell (PROD-732).
 *
 * Flutter `create_patient_screen.dart:1179` → `EmergencyContactsWidget`.
 * The Community tab is just the emergency-contacts list rendered in a
 * different visual frame (full-width centered card, vs the Contact
 * Details tab where it shares space with the form + addresses).
 *
 * Both tabs operate on the same `patient.emergencyContactResponse`
 * array via the same `useEmergencyContacts` / `useSaveEmergencyContacts`
 * hooks — there is no separate state. Edits made on this tab show up
 * on the Contact Details tab on next mount, and vice versa.
 *
 * Permission gate (`Patient_Contacts`) lives at the tab-strip in
 * `patient-edit-page.tsx`; this body trusts the parent's visibility
 * decision. Read-only mode mirrors PROD-728: `isMerged === true`
 * disables every control inside the section.
 */

import { FormSection } from '@/patients/components/personal-details/form-primitives';
import { EmergencyContactsSection } from '@/patients/components/emergency-contacts/emergency-contacts-section';
import type { Patient } from '@/types/patient-api';

export interface CommunityTabProps {
  patient: Patient | null;
}

export function CommunityTab({ patient }: CommunityTabProps) {
  const readOnly = patient?.isMerged === true;

  // Flutter constrains the body to maxWidth 674; mirror the left-aligned
  // FormSection layout used by Personal/Contact Details for consistency.
  return (
    <div className="max-w-3xl pb-32">
      <FormSection title="Emergency contacts">
        <EmergencyContactsSection
          patientId={patient?.patientId ?? null}
          readOnly={readOnly}
        />
      </FormSection>
    </div>
  );
}
